<template>
	<v-list-item
		v-if="!item.items"
		:disabled="!item.to"
		link
		:prepend-icon="item.icon"
		:title="$t(item.title)"
		:to="item.to"
	/>
</template>

<script setup lang="ts">
	import type DrawerMenuItem from "@/interfaces/DrawerMenuItemInterface";

	defineProps<{
		item: DrawerMenuItem;
	}>();
</script>
<style scoped></style>
